export var PLANNING_SHIFT_FULL_DAY_START_AT = '08:00:00';
export var PLANNING_SHIFT_FULL_DAY_END_AT = '17:00:00';
